import { Component } from '@angular/core';
import { MapItem } from '@capturum/ui/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmConfig } from '@shared/components/confirm/confirm-config.model';
import { Dialog } from 'primeng/dialog';
import { CapturumButtonComponent } from '@capturum/ui/button';
import { TranslatePipe } from '@ngx-translate/core';
import { RadioButton } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  imports: [Dialog, CapturumButtonComponent, TranslatePipe, RadioButton, FormsModule],
})
export class ConfirmComponent {
  public confirmConfig: ConfirmConfig;
  public selectedItem: MapItem;

  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
  ) {
    this.confirmConfig = config.data;

    if (this.confirmConfig?.options?.length > 0) {
      this.selectedItem = this.confirmConfig.options[0];
    }
  }

  public onAccept(): void {
    this.ref.close({ accept: true, value: this.selectedItem?.value });
  }

  public onReject(): void {
    this.ref.close({ accept: false });
  }
}
